<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Employee">
      <!-- <b-card-text>Employee.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Employee -->
            <b-col cols="12">
              <b-form-group label="Employee" label-for="v-employee">
                <validation-provider #default="{ errors }"  name="Employee" rules="required">
                  <b-form-input  id="v-employee-name" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Employee" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Gender -->
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  label="Gender"
                  label-for="gender"
                  label-class="mb-1"
                >
                  <b-form-radio-group
                    id="gender"
                    v-model="form.radio_2"
                    :options="genderOptions"
                    value="male"
                  />
                </b-form-group>
              </b-col>
            <!-- Birth Place -->
            <b-col cols="12"
              md="6"
              lg="4">
              <b-form-group label="Birth Place" label-for="v-Birth-Place">
                <validation-provider #default="{ errors }" name="Birth Place" >
                  <b-form-input id="v-Birth-Place" :state="errors.length > 0 ? false:null" v-model="form.text_3" placeholder="Birth Place" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Birth Date -->
            <b-col
              cols="12"
              md="6"
              lg="4"
            >
              <b-form-group
                label="Birth Date"
                label-for="birth-date"
              >
                <flat-pickr
                  v-model="form.date_4"
                  class="form-control"
                  :config="{ dateFormat: 'd-m-Y'}"
                  placeholder="DD-MM-YYYY"
                />
              </b-form-group>
            </b-col>
            <!-- Address -->
            <b-col cols="12"
              md="6"
              lg="4">
              <b-form-group label="Address" label-for="v-Address">
                <validation-provider #default="{ errors }" name="Address" >
                  <b-form-input id="v-Address" :state="errors.length > 0 ? false:null" v-model="form.text_5" placeholder="Address" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Province -->
            <b-col cols="12">
              <b-form-group label="Province" label-for="v-Province">
                <validation-provider #default="{ errors }"  name="Province">
                  <v-select id="v-Province" v-model="form.select_6" placeholder="Chose Province" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="provinceOptions" :reduce="provinceOptions => provinceOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Regency -->
            <b-col cols="12">
              <b-form-group label="Regency" label-for="v-Regency">
                <validation-provider #default="{ errors }"  name="Regency">
                  <v-select id="v-Regency" v-model="form.select_7" placeholder="Chose Regency" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="regencyOptions" :reduce="regencyOptions => regencyOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- District -->
            <b-col cols="12">
              <b-form-group label="District" label-for="v-District">
                <validation-provider #default="{ errors }"  name="District">
                  <v-select id="v-District" v-model="form.select_8" placeholder="Chose District" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="districtOptions" :reduce="districtOptions => districtOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Village -->
            <b-col cols="12">
              <b-form-group label="Village" label-for="v-Village">
                <validation-provider #default="{ errors }"  name="Village">
                  <v-select id="v-Village" v-model="form.select_9" placeholder="Chose Village" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="villageOptions" :reduce="villageOptions => villageOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCol, BFormGroup, BFormRadioGroup, BFormInput, BForm, BButton, BCard } from 'bootstrap-vue'
import { required } from '@validations'
import { mapState } from 'vuex'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, ValidationProvider, ValidationObserver, BCard, BRow, BCol, BFormGroup, flatPickr, BFormRadioGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      genderOptions: [
        { text: 'Male', value: 'M' },
        { text: 'Female', value: 'F' },
      ],
      form: {id: null, text_1: '', radio_2: '', text_3: '', date_4: '', text_5: '', select_6: '', select_7: '', select_8: '', select_9: ''},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ provinceOptions: state => state.region.province, regencyOptions: state => state.region.regency, districtOptions: state => state.region.district, villageOptions: state => state.region.village}),
    select_6() {
      return this.form.select_6;
    },
    select_7() {
      return this.form.select_7;
    },
    select_8() {
      return this.form.select_8;
    },
  },
  created () {
    this.$store.dispatch('region/province')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('employee/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('employee/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.radio_2 = data.gender
        this.form.text_3 = data.birth_place
        this.form.date_4 = data.birth_date
        this.form.text_5 = data.address
        this.form.select_6 = data.prov_id
        this.form.select_7 = data.rgcy_id
        this.form.select_8 = data.dstr_id
        this.form.select_9 = data.vllg_id
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>